import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveExit12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveExit12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.2 4.818c0 .248.202.45.45.45h2.909a.45.45 0 0 0 0-.9H7.65a.45.45 0 0 0-.45.45m.08 1.805c0 .248.201.45.45.45h1.978a.45.45 0 0 0 0-.9H7.729a.45.45 0 0 0-.449.45M.89 5.774a2.775 2.775 0 1 0 5.55 0 2.775 2.775 0 0 0-5.55 0m.9 0a1.876 1.876 0 1 1 3.75.002 1.876 1.876 0 0 1-3.75-.002"
            />
        </svg>
    );
}
export default memo(IconMoveExit12);
